<template>
  <div class="mask" @touchmove.prevent>
    <!-- 左上角图片计数 -->
    <div class="img-counter">{{ activeIndex + 1 }}/{{ imgUrls.length }}</div>
    <!-- 右上角关闭按钮 -->
    <div class="close-btn" @click="handleClose">
      <!-- eslint-disable -->
      <svg viewBox="0 0 24 24" width="24" height="24">
        <path
          d="M18.3 5.71a1 1 0 0 0-1.41 0L12 10.59 7.11 5.7A1 1 0 0 0 5.7 7.11L10.59 12 5.7 16.89a1 1 0 1 0 1.41 1.41L12 13.41l4.89 4.89a1 1 0 0 0 1.41-1.41L13.41 12l4.89-4.89a1 1 0 0 0 0-1.4z"
          fill="#fff"
        />
      </svg>
      <!-- eslint-enable -->
    </div>
    <!-- 轮播图 -->
    <div class="swiper-container" ref="swiperContainer">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(item, i) in imgUrls"
          :key="i"
        >
          <div
            class="img-wrapper"
            :style="i === activeIndex ? imgWrapperStyle : ''"
            @touchstart="onTouchStart($event, i)"
            @touchmove="onTouchMove($event, i)"
            @touchend="onTouchEnd($event, i)"
            @click.self="handleClose"
          >
            <img
              :src="item"
              draggable="false"
              @click="onImgClick($event, i)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from '../../../common/js/modules/swiper4';

export default {
  props: ['imgUrls', 'currentIndex'],
  data() {
    return {
      mySwiper: null,
      activeIndex: this.currentIndex || 0,
      top: window.scrollY,
      // 缩放相关
      scale: 1,
      translateX: 0,
      translateY: 0,
      // 手势状态
      isPinching: false,
      pinchStartDist: 0,
      pinchStartScale: 1,
      pinchCenterX: 0,
      pinchCenterY: 0,
      // 拖动状态
      isDragging: false,
      dragStartX: 0,
      dragStartY: 0,
      dragStartTranslateX: 0,
      dragStartTranslateY: 0,
      // 点击检测
      tapCount: 0,
      tapTimer: null,
      // 防止touchend后误触click
      touchMoved: false,
      multiTouched: false,
      // 过渡动画控制
      isAnimating: false,
      // 边界拖动切换相关
      isOverScrolling: false,
      overScrollX: 0,
      overScrollDirection: '',
      swiperBaseTranslate: 0,
    };
  },
  computed: {
    imgWrapperStyle() {
      return {
        transform: `translate3d(${this.translateX}px, ${this.translateY}px, 0) scale(${this.scale})`,
        transformOrigin: 'center center',
        transition: this.isAnimating ? 'transform 0.3s ease' : 'none',
      };
    },
    isZoomed() {
      return this.scale > 1;
    },
  },
  mounted() {
    this.initSwiper();
  },
  beforeDestroy() {
    if (this.mySwiper) {
      this.mySwiper.destroy(true, true);
      this.mySwiper = null;
    }
    document.body.style.position = '';
    document.body.style.top = '';
    window.scrollTo(0, this.top);
  },
  methods: {
    handleClose() {
      this.$emit('closeImagePopup');
    },
    initSwiper() {
      const options = {
        touchRatio: 1,
        initialSlide: this.currentIndex || 0,
        on: {
          slideChange: () => {
            if (this.mySwiper) {
              this.activeIndex = this.mySwiper.activeIndex;
              // 切换 slide 时重置缩放
              this.resetTransform();
            }
          },
        },
      };
      this.mySwiper = new Swiper(this.$refs.swiperContainer, options);
      document.body.style.position = 'fixed';
      document.body.style.top = `${-this.top}px`;
    },
    resetTransform() {
      this.scale = 1;
      this.translateX = 0;
      this.translateY = 0;
      this.enableSwiper();
    },
    clampPosition() {
      const containerWidth = window.innerWidth;
      const containerHeight = window.innerHeight;

      if (this.scale <= 1) {
        this.resetTransform();
        return;
      }

      const imgWidth = containerWidth * this.scale;
      const imgHeight = containerWidth * this.scale; // 图片宽度100%适配，高度先按正方形估算

      // 获取当前活动图片的实际高度
      const activeSlide = this.$refs.swiperContainer
        && this.$refs.swiperContainer.querySelectorAll('.swiper-slide');
      if (activeSlide) {
        const slides = Array.from(activeSlide);
        const currentSlide = slides.find((slide, idx) => {
          const img = slide.querySelector('img');
          return img && idx === this.activeIndex;
        }) || slides[this.activeIndex];
        if (currentSlide) {
          const img = currentSlide.querySelector('img');
          if (img && img.naturalWidth && img.naturalHeight) {
            const ratio = img.naturalHeight / img.naturalWidth;
            const actualImgHeight = containerWidth * ratio * this.scale;
            const actualImgWidth = imgWidth;

            let newTranslateX = this.translateX;
            let newTranslateY = this.translateY;

            // 水平约束
            if (actualImgWidth <= containerWidth) {
              newTranslateX = 0;
            } else {
              const maxTranslateX = (actualImgWidth - containerWidth) / 2;
              newTranslateX = Math.max(-maxTranslateX, Math.min(maxTranslateX, newTranslateX));
            }

            // 垂直约束
            if (actualImgHeight <= containerHeight) {
              newTranslateY = 0;
            } else {
              const maxTranslateY = (actualImgHeight - containerHeight) / 2;
              newTranslateY = Math.max(-maxTranslateY, Math.min(maxTranslateY, newTranslateY));
            }

            // 如果位置需要修正，启用动画
            if (newTranslateX !== this.translateX || newTranslateY !== this.translateY) {
              this.isAnimating = true;
              this.translateX = newTranslateX;
              this.translateY = newTranslateY;
              setTimeout(() => {
                this.isAnimating = false;
              }, 300);
            }
            return;
          }
        }
      }

      // 兜底逻辑：无法获取图片实际尺寸时，使用容器宽度作为图片高度
      let newTranslateX = this.translateX;
      let newTranslateY = this.translateY;

      if (imgWidth <= containerWidth) {
        newTranslateX = 0;
      } else {
        const maxTranslateX = (imgWidth - containerWidth) / 2;
        newTranslateX = Math.max(-maxTranslateX, Math.min(maxTranslateX, newTranslateX));
      }

      if (imgHeight <= containerHeight) {
        newTranslateY = 0;
      } else {
        const maxTranslateY = (imgHeight - containerHeight) / 2;
        newTranslateY = Math.max(-maxTranslateY, Math.min(maxTranslateY, newTranslateY));
      }

      if (newTranslateX !== this.translateX || newTranslateY !== this.translateY) {
        this.isAnimating = true;
        this.translateX = newTranslateX;
        this.translateY = newTranslateY;
        setTimeout(() => {
          this.isAnimating = false;
        }, 300);
      }
    },
    disableSwiper() {
      if (this.mySwiper) {
        this.mySwiper.allowTouchMove = false;
      }
    },
    enableSwiper() {
      if (this.mySwiper) {
        this.mySwiper.allowTouchMove = true;
      }
    },
    // 计算两指间距离
    getDistance(touches) {
      const dx = touches[0].clientX - touches[1].clientX;
      const dy = touches[0].clientY - touches[1].clientY;
      return Math.sqrt(dx * dx + dy * dy);
    },
    // 获取两指中心点
    getCenter(touches) {
      return {
        x: (touches[0].clientX + touches[1].clientX) / 2,
        y: (touches[0].clientY + touches[1].clientY) / 2,
      };
    },
    onTouchStart(event, index) {
      if (index !== this.activeIndex) return;
      this.touchMoved = false;
      this.multiTouched = false;

      const { touches } = event;
      if (touches.length === 2) {
        // 双指缩放开始
        event.preventDefault();
        this.isPinching = true;
        this.multiTouched = true;
        this.pinchStartDist = this.getDistance(touches);
        this.pinchStartScale = this.scale;
        const { x, y } = this.getCenter(touches);
        this.pinchCenterX = x;
        this.pinchCenterY = y;
        this.disableSwiper();
      } else if (touches.length === 1 && this.isZoomed) {
        // 单指拖动（放大状态下）
        event.preventDefault();
        this.isDragging = true;
        this.dragStartX = touches[0].clientX;
        this.dragStartY = touches[0].clientY;
        this.dragStartTranslateX = this.translateX;
        this.dragStartTranslateY = this.translateY;
        this.disableSwiper();
      }
    },
    onTouchMove(event, index) {
      if (index !== this.activeIndex) return;
      const { touches } = event;

      if (touches.length === 2 && this.isPinching) {
        // 双指缩放中
        event.preventDefault();
        this.touchMoved = true;
        const currentDist = this.getDistance(touches);
        let newScale = this.pinchStartScale * (currentDist / this.pinchStartDist);
        // 限制缩放范围
        newScale = Math.max(0.5, Math.min(3, newScale));
        // 缩放时同步调整 translate，防止缩小时图片跑出屏幕
        if (this.scale > 0) {
          const scaleRatio = newScale / this.scale;
          this.translateX *= scaleRatio;
          this.translateY *= scaleRatio;
        }
        this.scale = newScale;
      } else if (touches.length === 1 && this.isDragging && this.isZoomed) {
        // 放大状态下的单指拖动
        event.preventDefault();
        this.touchMoved = true;
        const dx = touches[0].clientX - this.dragStartX;
        const dy = touches[0].clientY - this.dragStartY;

        // 计算当前图片水平边界
        const containerWidth = window.innerWidth;
        const imgActualWidth = containerWidth * this.scale;
        const maxTranslateX = (imgActualWidth - containerWidth) / 2;

        // 计算新的 translateX
        const newTranslateX = this.dragStartTranslateX + dx;

        if (newTranslateX > maxTranslateX && dx > 0
          && !(this.activeIndex === 0)) {
          // 向右拖，左边缘已到屏幕左边 → 可切换上一张
          if (!this.isOverScrolling) {
            this.isOverScrolling = true;
            this.overScrollDirection = 'right';
            this.swiperBaseTranslate = this.mySwiper ? this.mySwiper.getTranslate() : 0;
          }
          this.translateX = maxTranslateX;
          this.overScrollX = newTranslateX - maxTranslateX;
          if (this.mySwiper) {
            this.mySwiper.setTranslate(this.swiperBaseTranslate + this.overScrollX);
          }
        } else if (newTranslateX < -maxTranslateX && dx < 0
          && !(this.activeIndex === this.imgUrls.length - 1)) {
          // 向左拖，右边缘已到屏幕右边 → 可切换下一张
          if (!this.isOverScrolling) {
            this.isOverScrolling = true;
            this.overScrollDirection = 'left';
            this.swiperBaseTranslate = this.mySwiper ? this.mySwiper.getTranslate() : 0;
          }
          this.translateX = -maxTranslateX;
          this.overScrollX = newTranslateX - (-maxTranslateX); // 负值
          if (this.mySwiper) {
            this.mySwiper.setTranslate(this.swiperBaseTranslate + this.overScrollX);
          }
        } else {
          // 正常拖动范围内
          if (this.isOverScrolling) {
            this.isOverScrolling = false;
            this.overScrollX = 0;
            // 恢复 Swiper translate 到基准位置
            if (this.mySwiper) {
              this.mySwiper.setTranslate(this.swiperBaseTranslate);
            }
          }
          this.translateX = newTranslateX;
        }
        this.translateY = this.dragStartTranslateY + dy;
      } else if (touches.length === 1 && !this.isZoomed) {
        // 正常状态下的单指滑动，交给 Swiper 处理
        this.touchMoved = true;
      }

      // 如果从单指变成双指
      if (touches.length === 2 && !this.isPinching) {
        this.isPinching = true;
        this.multiTouched = true;
        this.isDragging = false;
        this.pinchStartDist = this.getDistance(touches);
        this.pinchStartScale = this.scale;
        this.disableSwiper();
      }
    },
    onTouchEnd(event, index) {
      if (index !== this.activeIndex) return;

      const { touches } = event;
      // 还有手指在屏幕上（双指变单指）
      if (touches.length === 1 && this.isPinching) {
        this.isPinching = false;
        // 转为单指拖动
        if (this.isZoomed) {
          this.isDragging = true;
          this.dragStartX = touches[0].clientX;
          this.dragStartY = touches[0].clientY;
          this.dragStartTranslateX = this.translateX;
          this.dragStartTranslateY = this.translateY;
        }
        return;
      }

      // 所有手指离开
      if (touches.length === 0) {
        // 优先处理 overscroll 状态（无论是否 multiTouched）
        if (this.isDragging && this.isOverScrolling) {
          const threshold = window.innerWidth / 3;
          if (Math.abs(this.overScrollX) > threshold) {
            // 超过阈值，切换图片
            if (this.overScrollDirection === 'left') {
              this.mySwiper.slideNext(300);
            } else {
              this.mySwiper.slidePrev(300);
            }
          } else {
            // 未超过阈值，回弹到当前 slide
            if (this.mySwiper) {
              this.mySwiper.slideTo(this.activeIndex, 300);
            }
            this.clampPosition();
          }
          // 重置 overscroll 状态
          this.isOverScrolling = false;
          this.overScrollX = 0;
          this.swiperBaseTranslate = 0;
          this.overScrollDirection = '';
          this.isDragging = false;
          this.multiTouched = false;
          this.isPinching = false;
          return;
        }

        if (this.isPinching || this.multiTouched) {
          this.isPinching = false;
          // 缩放比例小于1则回弹到1
          if (this.scale < 1) {
            this.isAnimating = true;
            this.scale = 1;
            this.translateX = 0;
            this.translateY = 0;
            setTimeout(() => {
              this.isAnimating = false;
            }, 300);
          }
          // 恢复或禁用 Swiper
          if (!this.isZoomed) {
            this.resetTransform();
          } else {
            // 缩放结束后约束位置
            this.clampPosition();
          }
        } else if (this.isDragging) {
          // 正常拖动结束后约束位置
          this.clampPosition();
        }
        this.isDragging = false;
      }
    },
    onImgClick(event, index) {
      if (index !== this.activeIndex) return;
      // 如果发生了移动或者多指操作，不处理点击
      if (this.touchMoved || this.multiTouched) {
        return;
      }
      this.tapCount++;

      if (this.tapCount === 1) {
        this.tapTimer = setTimeout(() => {
          // 单击：关闭预览
          if (this.tapCount === 1) {
            this.handleClose();
          }
          this.tapCount = 0;
        }, 280);
      } else if (this.tapCount === 2) {
        // 双击：切换缩放
        clearTimeout(this.tapTimer);
        this.tapCount = 0;
        this.handleDoubleTap(event);
      }
    },
    handleDoubleTap(event) {
      if (this.scale === 1) {
        this.scale = 2;
        // 以点击位置为中心放大
        const rect = event.target.getBoundingClientRect();
        const offsetX = event.clientX - (rect.left + rect.width / 2);
        const offsetY = event.clientY - (rect.top + rect.height / 2);
        this.translateX = -offsetX;
        this.translateY = -offsetY;
        this.disableSwiper();
        this.$nextTick(() => {
          this.clampPosition();
        });
      } else if (this.scale === 2) {
        this.scale = 3;
        // 保持当前偏移位置
        const rect = event.target.getBoundingClientRect();
        const offsetX = event.clientX - (rect.left + rect.width / 2);
        const offsetY = event.clientY - (rect.top + rect.height / 2);
        this.translateX = -offsetX * 1.5;
        this.translateY = -offsetY * 1.5;
        this.disableSwiper();
        this.$nextTick(() => {
          this.clampPosition();
        });
      } else {
        // 回到 1x
        this.isAnimating = true;
        this.resetTransform();
        setTimeout(() => {
          this.isAnimating = false;
        }, 300);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../common/css/common-mixin";
@import "../css/swiper";

.mask {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 1);
}

.img-counter {
  position: fixed;
  z-index: 1001;
  top: 0.4rem;
  left: 0.32rem;
  color: #fff;
  font-size: 0.32rem;
  line-height: 1;
  user-select: none;
}

.close-btn {
  position: fixed;
  z-index: 1001;
  top: 0.24rem;
  right: 0.24rem;
  width: 0.72rem;
  height: 0.72rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  svg {
    width: 0.48rem;
    height: 0.48rem;
  }
}

.swiper-container {
  position: absolute;
  z-index: inherit;
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  overflow: visible;
  .swiper-slide {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    .img-wrapper {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: none;
      will-change: transform;
      img {
        width: 100%;
        display: block;
        user-select: none;
        -webkit-user-drag: none;
        pointer-events: auto;
      }
    }
  }
}

::-webkit-scrollbar {
  display: none;
}
</style>
